import React from 'react';
import {
	TeamMemberWrapper,
	TeamMemberDetails,
	TeamMemberPhoto,
	TeamMemberName,
	TeamMemberDetail,
	TeamMemberComment,
} from './styles-team';

const TeamProfile = ({profile}) => {
	return (
		<TeamMemberWrapper>
			<TeamMemberPhoto src={profile.image} alt={profile.name} />
			<TeamMemberDetails>
				<div>
					<TeamMemberName>
						<b>{profile.name}</b>
					</TeamMemberName>
					<TeamMemberDetail>{profile.title}</TeamMemberDetail>
				</div>
				<div>
					<TeamMemberComment>
						<i>"{profile.comment}"</i>
					</TeamMemberComment>
				</div>
			</TeamMemberDetails>
		</TeamMemberWrapper>
	);
};

export default TeamProfile;
